import React from 'react';
import styles from './ContentPager.module.css';
import arrow from './arrow.jpg';

const ContentPager=(props)=>{
	const next=()=>{
		/* Adds page size to increament till it reaches size of contente.*/
		let new_increment=props.page_size;
		if(props.page_size>props.length-props.increment)
			new_increment=props.length-props.increment;
		props.update(new_increment);
	}

	const prev=()=>{
		/* subtracts page size to incereament till it reaches 0*/
		let new_increment=-props.page_size;
		if(props.increment<=0)
			new_increment=0;
		props.update(new_increment);
	}

	const setPage=(page)=>{
		props.update((page*props.page_size)-props.increment);
	}

	let prev_button=null;
	if(props.increment>0)
		prev_button=<img alt="" src={arrow} onClick={prev}/>

	let next_button=null;
	if(props.increment+props.page_size<props.length)
		next_button=<img alt="" src={arrow} onClick={next}/>
	
	let pages=Math.ceil(props.length/props.page_size);
	let indicators=[];

	if(pages>1)
		for(let i=0;i<pages;i++)
			indicators.push(<div className={[styles.indicator,props.increment===i*props.page_size?styles.active:undefined].join(' ')} onClick={()=>setPage(i)}></div>)
	
	return (
		<div className={styles.container}>
			<div className={styles.prev}>
				{prev_button}
			</div>
			{indicators}
			<div className={styles.next}>
				{next_button}
			</div>
		</div>
	);
}

export default ContentPager;